import React from 'react';
import { DrawerHeader, ModalProps } from '@features/Modal';
import { useErrorNotify } from '@features/useErrorNotify';
import { useAsyncData } from '@shared/react';
import { General } from './components';
import { getReserves } from '../../api';
import { IReserveComputationDate } from '@widgets/ReserveComputationTable/lib';
import './ReserveComputationDrawer.scss';
import moment from 'moment-timezone';

interface IReserveComputationDrawerProps extends ModalProps {
    date: IReserveComputationDate;
}

export const ReserveComputationDrawer: React.FC<IReserveComputationDrawerProps> = ({ date }) => {
    const {
        data: reserveComputation,
        loading: reserveComputationLoading,
        error: reserveComputationError,
    } = useAsyncData(
        async () => {
            const query = {
                fromDate: moment(date.date).startOf('day').format(),
                toDate: moment(date.date).endOf('day').format(),
            };
            return await getReserves(query);
        },
        null,
        [date],
    );
    useErrorNotify(reserveComputationError, 'Payment Request');

    return (
        <div className='widget-reserve-computation-drawer'>
            <DrawerHeader headerTitle={`${date.date}`} />
            {!!reserveComputation && <General data={reserveComputation} />}
        </div>
    );
};
